<template>
    <div>
        <DesktopHeader class="hidden lg:block" :data />
        <MobileNavigation class="block lg:hidden" :data />
    </div>
</template>

<script lang="ts" setup>
import type { HeaderNavigationModel } from '@su4r-frontend/api';

const { data } = defineProps<{ data: HeaderNavigationModel }>();
</script>
